<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>Confirmar recepción del pedido</span>
  <button mat-icon-button (click)="cancel()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content style="display:flex; flex-direction:column; gap:16px;">

  <!-- INFO GENERAL -->
  <div>
    <strong>Proveedor:</strong> {{ order.supplierName }}
  </div>
  <div>
    <strong>Fecha:</strong> {{ order.orderDate | date:'dd/MM/yyyy' }}
  </div>

  <!-- TABLA DE LÍNEAS -->
  <table mat-table [dataSource]="order.lines" class="mat-elevation-z1">

    <!-- Producto -->
    <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef>Producto</th>
      <td mat-cell *matCellDef="let line">{{ line.productName }}</td>
    </ng-container>

    <!-- Cantidad pedida -->
    <ng-container matColumnDef="ordered">
      <th mat-header-cell *matHeaderCellDef>Pedida</th>
      <td mat-cell *matCellDef="let line">{{ line.quantityOrdered }}</td>
    </ng-container>

    <!-- Cantidad recibida -->
    <ng-container matColumnDef="received">
      <th mat-header-cell *matHeaderCellDef>Recibida</th>
      <td mat-cell *matCellDef="let line">
        <input
          matInput
          type="number"
          min="0"
          [max]="line.quantityOrdered"
          [(ngModel)]="line.quantityReceived"
          placeholder="0"
        />
      </td>
    </ng-container>

    <!-- HEADER y ROW -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="confirm()">
    Confirmar
  </button>
</mat-dialog-actions>